import { render, staticRenderFns } from "./GoodsSeriesGatherPositions.vue?vue&type=template&id=2f05d677&scoped=true&"
import script from "./GoodsSeriesGatherPositions.vue?vue&type=script&lang=js&"
export * from "./GoodsSeriesGatherPositions.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSeriesGatherPositions.vue?vue&type=style&index=0&id=2f05d677&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f05d677",
  null
  
)

export default component.exports